import React from 'react';
import { Box, Typography } from '@mui/material';
import ColoredTitle from './ColoredTitle';
import { useTheme } from '@emotion/react';

const OverviewContent = ({ item, ind }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 5,
        p: 2,
        height: '100%',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'column',
          mb: 3,
        },
      }}
    >
      <Box
        sx={{
          flex: 0.3,
          height: '100%',
          display: 'grid',
          [theme.breakpoints.down('lg')]: {
            width: '100%',
            mb: 2,
            flex: 1,
          },
        }}
      >
        <ColoredTitle item={item} index={ind} />
      </Box>
      <Box
        sx={{
          flex: 0.7,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          [theme.breakpoints.down('lg')]: {
            width: '100%',
            flex: 1,
          },
        }}
      >
        <Typography variant='caption' textAlign={'justify'} sx={{ width: '100%' }}>
          {item.description.map((point, ind) => {
            return ind === 0 && item.highlight ? (
              <Typography
                key={ind}
                component='h5'
                fontWeight={'bold'}
                textAlign={'left'}
                fontSize={{ md: '1.2rem', xl: '1.5rem' }}
              >
                {point}
              </Typography>
            ) : (
              <Typography key={ind} component={item.type} sx={{ mb: 1, fontSize: { md: '0.9rem', xl: '1.5rem' } }}>
                {point}
              </Typography>
            );
          })}
        </Typography>
      </Box>
    </Box>
  );
};

export default OverviewContent;
